import Vue from 'vue';

class VsLoading {
    vs;

    constructor() {
        this.vs = Vue.prototype.$vs;
    }

    loading(container, status) {
        if(status) {
            this.vs.loading({
                container,
                scale: 0.6
            })
        } else {
            this.vs.loading.close(`${container} > .con-vs-loading`);
        }
    } 
}

const vsLoading = new VsLoading();

export default vsLoading;


// WEBPACK FOOTER //
// ./src/core/helpers/vsLoading.js